import Vue from 'vue'
import api from '@/api/request'

export default Vue.use({
  install(_Vue) {
    if (!_Vue.prototype.hasOwnProperty('$_api')) {
      Object.defineProperty(_Vue.prototype, '$_api', {
        get() {
          return api
        }
      })
    }
  }
})